import { render } from "./ServiceFee.vue?vue&type=template&id=17294cd6&scoped=true&ts=true"
import script from "./ServiceFee.vue?vue&type=script&lang=ts"
export * from "./ServiceFee.vue?vue&type=script&lang=ts"

import "./ServiceFee.vue?vue&type=style&index=0&id=17294cd6&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17294cd6"]])

export default __exports__